module.exports = __webpack_public_path__ + "static/media/Nasscom03.3fea14c7.jpg";